import { mapGetters } from 'vuex';
import { GETTERS } from '../store/wizard/types';

const next = {
    computed: {
        ...mapGetters({
            getRouteParams: GETTERS.GET_ROUTE_PARAMS,
        })
    },
    methods: {
        next(name, replace = false) {
            const params = this.getRouteParams(name);
            return this.$router[replace ? 'replace' : 'push']({ name, params })
                .catch(e => {
                    throw e;
                });
        }
    }
};

export default next;
